// used as a way to expose a public API for everything that is usable outside the feature folder for that given feature
// if it is only used in the feature, you don't need to export it

//Providers
//Firebase
import {
  FirebaseAuthContext as AuthContext,
  FirebaseAuthProvider as AuthProvider,
  logoutFirebase as logout,
  refreshFirebaseToken as refreshToken,
} from './clients/firebase/FirebaseAuthProvider';
//Components
import { Login } from './components/login';
import { Register } from './components/register';
//Utils
import { useAuth } from './hooks/useAuth';
import { persistAuth } from './utils/persistAuth';

//Cognito
// import {
//     CognitoAuthProvider as AuthProvider,
//     CognitoAuthContext as AuthContext,
//     refreshCognitoToken as refreshToken,
//     logoutCognito as logout
// } from './clients/cognito/CognitoAuthProvider'

export {
  AuthContext,
  AuthProvider,
  Login,
  Register,
  logout,
  persistAuth,
  refreshToken,
  useAuth,
};
